import React, { useState, useEffect } from "react";
import { API, UPLOADS } from "./../../config/api";
export default function Pendingmachine() {
  const [machines, setMachines] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedMachine, setSelectedMachine] = useState(null);

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentImage, setPaymentImage] = useState("");
  useEffect(() => {
    fetchMachines();
  }, []);

  const fetchMachines = async () => {
    try {
      // UPDATED: Points to unified api.php and specifically asks for Pending status
      const res = await fetch(API.LIST_PENDING_MACHINES);
      const data = await res.json();
      setMachines(data);
    } catch (error) {
      console.log("Fetch Error:", error);
    }
  };

  const handleView = (machine) => {
    setSelectedMachine(machine);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleStatus = async (status) => {
    if (status === "Rejected") {
      const confirmDelete = window.confirm(
        "Are you sure? Rejecting this machine will permanently delete it from the database and remove its images.",
      );
      if (!confirmDelete) return;
    }

    try {
      const formData = new FormData();
      formData.append("id", selectedMachine.id);

      // Determine the action based on the button clicked

      if (status === "Active") {
        formData.append("status", "Active");
      }

      const apiUrl =
        status === "Rejected" ? API.DELETE_MACHINE : API.UPDATE_MACHINE_STATUS;

      const res = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      alert(data.message);

      setShowModal(false);
      fetchMachines(); // Refresh the list
    } catch (error) {
      console.log("Operation Error:", error);
    }
  };

  return (
    <div className="dashboard-content">
      <h2 className="machine-title">Pending Machine Requests</h2>

      <div className="table-responsive">
        <table className="machine-table">
          <thead>
            <tr>
              <th>#</th>
              <th>User Id</th>
              <th>Date</th>
              <th>Seller</th>
              <th>Machine Type</th>

              <th>Ads</th>
              {/* <th>Location</th> */}
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {machines.length > 0 ? (
              machines.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td data-label="user id">{item.user_id}</td>
                  <td>
                    {" "}
                    <div className="fw-bold">
                      {new Date(item.created_at).toLocaleDateString()}
                    </div>
                    <div className="text-muted small">
                      {new Date(item.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>
                  <td>
                    <div className="fw-bold">{item.name}</div>
                    <div className="text-muted small">{item.phone}</div>
                  </td>
                  <td>
                    <div className="fw-bold">{item.machine_name}</div>
                    <div className="text-muted small">₹ {item.price}</div>
                  </td>

                  <td>
                    <div className="fw-bold">{item.show_ads_days} Days</div>
                    <div className="text-muted small">₹{item.ads_amount}</div>
                  </td>
                  {/* <td>{item.city}</td> */}
                  <td>
                    <span className="status-pending">{item.status}</span>
                  </td>
                  <td>
                    <button
                      className="view-btn"
                      onClick={() => handleView(item)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No pending machines found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* POPUP MODAL */}
      {showModal && selectedMachine && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>⚙ Machine Details</h3>
            </div>
            <div className="popup-grid">
              <div>
                <label>Machine Type</label>
                <p>{selectedMachine.machine_name}</p>
              </div>
              <div>
                <label>Left Side Head Type</label>
                <p>{selectedMachine.left_head_type}</p>
              </div>
              <div>
                <label>Right Side Head Type</label>
                <p>{selectedMachine.right_head_type}</p>
              </div>
              <div>
                <label>Brand</label>
                <p>{selectedMachine.brand}</p>
              </div>

              <div>
                <label>Model</label>
                <p>{selectedMachine.model}</p>
              </div>

              <div>
                <label>No Of Heads</label>
                <p>{selectedMachine.NoOfHeads}</p>
              </div>

              <div>
                <label>NO Of Needles</label>
                <p>{selectedMachine.NoOfNeedls}</p>
              </div>
              <div>
                <label>Max Sewing Speed(RPM)</label>
                <p>{selectedMachine.Maxsewingspeed}</p>
              </div>
              <div>
                <label>Beam Body Size (MM)</label>
                <p>{selectedMachine.beamBody}</p>
              </div>

              <div>
                <label>Motor</label>
                <p>{selectedMachine.motor}</p>
              </div>

              <div>
                <label>Usb Port</label>
                <p>{selectedMachine.usbport}</p>
              </div>
              <div>
                <label>Machine Age</label>
                <p>{selectedMachine.machine_old}</p>
              </div>
              <div>
                <label>Price(Rs)</label>
                <p>₹ {selectedMachine.price}</p>
              </div>

              <div>
                <label>Status</label>
                <p>{selectedMachine.status}</p>
              </div>

              <div>
                <label>City</label>
                <p>{selectedMachine.city}</p>
              </div>

              <div>
                <label>Seller</label>
                <p>
                  {selectedMachine.name} ({selectedMachine.phone})
                </p>
              </div>

              <div>
                <label>Location</label>
                <p>
                  {selectedMachine.location}, {selectedMachine.city},{" "}
                  {selectedMachine.state}
                </p>
              </div>

              <div>
                <label>Ads Duration</label>
                <p>{selectedMachine.show_ads_days}</p>
              </div>

              <div>
                <label> Payed Amount</label>
                <p>{selectedMachine.ads_amount}</p>
              </div>
            </div>
            {selectedMachine.payment_screenshot && (
              <div className="payment-proof-section">
                <label>Payment Screenshot</label>

                <div
                  className="popup-images"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPaymentImage(
                      `${UPLOADS.MACHINE_IMAGE}${selectedMachine.user_id}/payment/${selectedMachine.payment_screenshot}`,
                    );
                    setShowPaymentModal(true);
                  }}
                >
                  <img
                    src={`${UPLOADS.MACHINE_IMAGE}${selectedMachine.user_id}/payment/${selectedMachine.payment_screenshot}`}
                    alt="payment"
                    style={{
                      maxWidth: "300px",
                      borderRadius: "10px",
                      border: "1px solid #ddd",
                      padding: "5px",
                      transition: "transform 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                    }}
                  />
                  {/* <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      background: "rgba(0,0,0,0.7)",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "12px",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    🔍 Click to enlarge
                  </div> */}
                </div>
              </div>
            )}
            {showPaymentModal && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0,0,0,0.9)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "20px",
                }}
                onClick={() => setShowPaymentModal(false)}
              >
                <div
                  style={{
                    position: "relative",
                    maxWidth: "90vw",
                    maxHeight: "90vh",
                  }}
                >
                  {/* Close Button */}
                  <button
                    onClick={() => setShowPaymentModal(false)}
                    style={{
                      position: "absolute",
                      top: "-15px",
                      right: "-15px",
                      background: "#ff4444",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      zIndex: 10000,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    }}
                  >
                    ×
                  </button>

                  {/* Large Image */}
                  <img
                    src={paymentImage}
                    alt="Payment Proof - Large View"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "90vh",
                      width: "auto",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
                      objectFit: "contain",
                    }}
                  />

                  {/* Zoom Controls */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: "20px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      display: "flex",
                      gap: "10px",
                    }}
                  >
                    {/* <button
                      onClick={(e) => {
                        e.stopPropagation();
                        // You can add zoom functionality here
                        console.log("Zoom In");
                      }}
                      style={{
                        padding: "8px 16px",
                        background: "#4CAF50",
                        color: "white",
                        border: "none",
                        borderRadius: "20px",
                        cursor: "pointer",
                      }}
                    >
                      ➕ Zoom In
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        // You can add zoom functionality here
                        console.log("Zoom Out");
                      }}
                      style={{
                        padding: "8px 16px",
                        background: "#f44336",
                        color: "white",
                        border: "none",
                        borderRadius: "20px",
                        cursor: "pointer",
                      }}
                    >
                      ➖ Zoom Out
                    </button> */}
                  </div>
                </div>
              </div>
            )}
            {showPaymentModal && (
              <div
                className="image-modal-overlay"
                onClick={() => setShowPaymentModal(false)}
              >
                <div
                  className="image-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="image-close-btn"
                    onClick={() => setShowPaymentModal(false)}
                  >
                    ✖
                  </button>

                  <img
                    src={paymentImage}
                    alt="Payment Full"
                    className="full-payment-image"
                  />
                </div>
              </div>
            )}
            <div className="description-box">
              <label>Description</label>
              <p>{selectedMachine.description}</p>
            </div>
            <div className="popup-images">
              {selectedMachine.image &&
                selectedMachine.image
                  .split(",")
                  .map((img, i) => (
                    <img
                      key={i}
                      src={`${UPLOADS.MACHINE_IMAGE}${selectedMachine.user_id}/${img}?t=${Date.now()}`}
                      alt="preview"
                    />
                  ))}
            </div>
            <div className="modal-actions">
              <button
                className="btn btn-success"
                onClick={() => handleStatus("Active")}
              >
                <i className="bi bi-check-lg"></i> Accept & Activate
              </button>
              <button
                className="btn btn-danger"
                onClick={() => handleStatus("Rejected")}
              >
                <i className="bi bi-trash"></i> Reject & Delete
              </button>
              <button className="btn btn-secondary" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* {showPaymentModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.9)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
          onClick={() => setShowPaymentModal(false)}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90vw",
              maxHeight: "90vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowPaymentModal(false)}
              style={{
                position: "absolute",
                top: "-15px",
                right: "-15px",
                background: "#ff4444",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "18px",
                fontWeight: "bold",
                cursor: "pointer",
                zIndex: 10000,
                boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
              }}
            >
              ×
            </button>

            <img
              src={paymentImage}
              alt="Payment Proof Large"
              style={{
                maxWidth: "100%",
                maxHeight: "90vh",
                width: "auto",
                height: "auto",
                borderRadius: "12px",
                boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      )} */}
    </div>
  );
}
